<template>
  <transition name="submenu-fade">
    <div class="submenu-fixed bg-blue-900 overflow-visible shadow-lg border border-blue-700 border-l-0" 
         v-if="active" 
         :style="menuStyle"
         @mouseenter="onMouseEnter"
         @mouseleave="onMouseLeave">
      <div class="triangle-indicator"></div>
      <div class="py-3 px-2 text-base font-bold text-white bg-blue-800 bg-opacity-90 border-b border-opacity-10 border-white text-left flex items-center">
        <div class="submenu-title-indicator"></div>{{ title }}
      </div>
      <div class="flex flex-wrap p-2">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SubMenu',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    menuStyle: {
      type: Object,
      required: true
    },
    menuName: {
      type: String,
      required: true
    }
  },
  methods: {
    onMouseEnter() {
      this.$emit('submenu-enter', this.menuName);
    },
    onMouseLeave() {
      this.$emit('submenu-leave');
    }
  }
}
</script>

<style scoped>
.submenu-fixed {
  position: fixed !important;
  z-index: 9999 !important;
  width: 280px !important;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  pointer-events: auto !important;
  backface-visibility: hidden; /* 促进硬件加速 */
  will-change: transform, opacity; /* 提示浏览器此元素将会变化 */
}

/* 过渡动画效果 */
.submenu-fade-enter-active, .submenu-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.submenu-fade-enter-from, .submenu-fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.triangle-indicator {
  position: absolute;
  left: -10px;
  top: 20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #ff7a45;
  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.1));
}

.submenu-title-indicator {
  width: 6px;
  min-width: 6px;
  height: 20px;
  background-color: #ff7a45;
  margin-right: 12px;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.submenu-fixed::-webkit-scrollbar {
  width: 4px;
}

.submenu-fixed::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

.submenu-fixed::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.submenu-fixed::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style> 